// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Live page shell. Mirrors the section pages' top/side padding and max width
   but stays full-height so the operator inbox fills the viewport (no 48px
   bottom padding — the inbox manages its own scroll). */
.live-page {
  max-width: var(--max-width-10xl, 120rem);
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px 24px;
  font-family: "DM Sans", sans-serif;
  color: #2b2b35;
}

.live-inbox-host {
  position: relative;
  flex: 1 1;
  min-height: 0;
}

.live-inbox-spinner {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 10;
}

.live-inbox-fill {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveChat.css"],"names":[],"mappings":"AAAA;;wDAEwD;AACxD;EACE,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Live page shell. Mirrors the section pages' top/side padding and max width\r\n   but stays full-height so the operator inbox fills the viewport (no 48px\r\n   bottom padding — the inbox manages its own scroll). */\r\n.live-page {\r\n  max-width: var(--max-width-10xl, 120rem);\r\n  margin: 0 auto;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 22px 24px 24px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #2b2b35;\r\n}\r\n\r\n.live-inbox-host {\r\n  position: relative;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.live-inbox-spinner {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #fff;\r\n  z-index: 10;\r\n}\r\n\r\n.live-inbox-fill {\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
